import api from '../client';

/**
 * Service pour la gestion de la base de connaissances
 */
const knowledgeService = {
  /**
   * Rechercher dans la base de connaissances
   * @param {Object} params - Paramètres (q, category, limit)
   * @returns {Promise} Résultats de recherche
   */
  search: async (params) => {
    try {
      const response = await api.get('/knowledge/search', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Récupérer tous les documents
   * @param {Object} params - Paramètres (category, page, limit)
   * @returns {Promise} Liste des documents
   */
  getDocuments: async (params = {}) => {
    try {
      const response = await api.get('/knowledge', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Récupérer un document par son ID
   * @param {string} id - ID du document
   * @returns {Promise} Données du document
   */
  getDocumentById: async (id) => {
    try {
      const response = await api.get(`/knowledge/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Uploader un nouveau document
   * @param {FormData} formData - Données du formulaire avec le fichier
   * @returns {Promise} Document créé
   */
  uploadDocument: async (formData) => {
    try {
      const response = await api.post('/knowledge', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Mettre à jour un document
   * @param {string} id - ID du document
   * @param {Object} documentData - Nouvelles données
   * @returns {Promise} Document mis à jour
   */
  updateDocument: async (id, documentData) => {
    try {
      const response = await api.put(`/knowledge/${id}`, documentData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Supprimer un document
   * @param {string} id - ID du document
   * @returns {Promise} Confirmation de suppression
   */
  deleteDocument: async (id) => {
    try {
      const response = await api.delete(`/knowledge/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Récupérer les catégories
   * @returns {Promise} Liste des catégories
   */
  getCategories: async () => {
    try {
      const response = await api.get('/knowledge/categories');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default knowledgeService;
